import { forwardRef, useState } from 'react'

import type { SwitcherProps } from './types'

const Switcher = forwardRef<HTMLInputElement, SwitcherProps>(
  ({ label, supportMsg, onClick, checked, ...props }, ref): JSX.Element => {
    const [isChecked, setIsChecked] = useState(checked ?? false)

    const handleCheckboxChange = (): void => {
      setIsChecked((prev) => {
        const newValue = !prev

        onClick?.(newValue)

        return newValue
      })
    }

    return (
      <div className='relative flex flex-col items-center'>
        <div className='flex w-full items-center'>
          <div className='mr-4'>
            <label htmlFor='check' className='flex cursor-pointer m-0 text-neutral-900'>
              {label}
            </label>
            {supportMsg ? <p className='font-normal text-neutral-500'>{supportMsg}</p> : null}
          </div>
          <div className='inline-flex relative h-5 items-center m-0 ml-auto cursor-pointer'>
            <input
              type='checkbox'
              className='sr-only peer'
              checked={isChecked}
              readOnly
              ref={ref}
              {...props}
            />
            <button
              data-test='checkbox-button'
              id='check'
              type='button'
              onClick={handleCheckboxChange}
              className="w-8 h-4 bg-neutral-200 rounded-full peer focus:outline-none focus-visible:ring-info-200 peer-focus:ring-info-200 peer-checked:after:translate-x-full peer-checked:after:border-info-200 after:content-[''] after:absolute after:top-1/2 after:-translate-y-1/2 after:inset-x-0 after:bg-info-400 after:border after:border-info-200 after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-info-200"></button>
          </div>
        </div>
      </div>
    )
  }
)

export default Switcher
